var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgThumbnailIconMobile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10a1.5 1.5 0 0 1 1.5 1.5v12.214c0 1.206-.82 2.196-1.857 2.28L25 26H11c-1.055 0-1.922-.938-1.995-2.123L9 23.714V11.5a1.5 1.5 0 0 1 1.5-1.5h15zm.5 13H10v.882c0 .604.392 1.106.891 1.17l.109.007h14c.513 0 .94-.461.994-1.049l.006-.128V23zm0-9H10v8h16v-8zm-8 1a.5.5 0 0 1 .5.5l-.001 2H20.5a.5.5 0 1 1 0 1h-2.001l.001 2a.5.5 0 1 1-1 0l-.001-2H15.5a.5.5 0 1 1 0-1h1.999l.001-2a.5.5 0 0 1 .5-.5z",
    fill: "#AEAEBD",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgThumbnailIconMobile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/thumbnail_icon_mobile.0f7c74c2.svg";
export { ForwardRef as ReactComponent };